export default __webpack_public_path__ + "static/media/amount.670a7605.svg";